/**
 * This Class have to be extend for each
 * retailers it provide function witch have to implement
 */
export class CoreInitializer {

  _userWrapper
  _storeWrapper
  _lastSupplierId


  /**
   * @param {string} supplierId id of supplier in miam API
   * @param {Class} basketHandlerClass class use for _basketHandler default is core class
   * it can be override to add custom behaviour
   */
  constructor(supplierId, userWrapper, storeWrapper, analyticsDomain) {
    this._userWrapper = userWrapper;
    this._storeWrapper = storeWrapper;
    this.initAnalytics(analyticsDomain);
    this.initInjector(supplierId);
  }

  /**
   * Enable Miam analytics if user authorized performance cookies
   */
  initAnalytics(analyticsDomain) {
    window.mealz.analytics.init(analyticsDomain);
  }

  /**
   * @generic
   * @param {string} supplierId  id of supplier in miam API
   */
  initInjector(supplierId) {
    if (supplierId !== this._lastSupplierId) {
      window.mealz.hook.setHookCallback((isLogged, isPosValid) => {
        return this._storeWrapper.hookCallback(isLogged, isPosValid);
      });
      window.mealz.hook.setForcePosCallback((posExtId) => {
        return this._storeWrapper.forcePosCallback(posExtId);
      });
      window.mealz.supplier.load(supplierId);
      const extId = this._storeWrapper.getPosExtId();
      if (extId.length > 0) {
        window.mealz.pos.load(extId);
      }
      else {
        window.mealz.pos.load(undefined);
      }
      this._lastSupplierId = supplierId;
    }
  }
}
